/* @refresh reload */
import { render } from 'solid-js/web';
import { Router, Route } from '@solidjs/router';
import { lazy, type JSX, type ParentComponent } from 'solid-js';

import './styles/global.css';
import { HomePage } from '~/pages/HomePage';
import { RadioPlayer } from '~/components/RadioPlayer';
import { CookieBanner } from '~/components/CookieBanner';

const CaterpillarPage = lazy(() => import('~/pages/CaterpillarPage'));
const OrderEnginePage = lazy(() => import('~/pages/OrderEnginePage'));
const NotFoundPage = lazy(() => import('~/pages/NotFoundPage'));

const PrivacyPolicyPage = lazy(() => import('~/pages/legal/PrivacyPolicyPage'));
const PersonalDataConsentPage = lazy(
  () => import('~/pages/legal/PersonalDataConsentPage'),
);
const CookiePolicyPage = lazy(() => import('~/pages/legal/CookiePolicyPage'));
const TermsPage = lazy(() => import('~/pages/legal/TermsPage'));
const CompanyDetailsPage = lazy(() => import('~/pages/legal/CompanyDetailsPage'));

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root not found');

/**
 * Корневой layout роутера. SolidRouter не размонтирует его при смене
 * маршрута, поэтому RadioPlayer и CookieBanner живут всю сессию.
 */
const AppShell: ParentComponent = (props): JSX.Element => (
  <>
    {props.children}
    <RadioPlayer />
    <CookieBanner />
  </>
);

render(
  () => (
    <Router root={AppShell}>
      <Route path="/" component={HomePage} />
      <Route path="/products/caterpillar-3412e" component={CaterpillarPage} />
      <Route path="/products/:slug" component={OrderEnginePage} />
      <Route path="/privacy-policy" component={PrivacyPolicyPage} />
      <Route path="/personal-data-consent" component={PersonalDataConsentPage} />
      <Route path="/cookie-policy" component={CookiePolicyPage} />
      <Route path="/terms" component={TermsPage} />
      <Route path="/company-details" component={CompanyDetailsPage} />
      <Route path="*" component={NotFoundPage} />
    </Router>
  ),
  root,
);
